module.exports = __webpack_public_path__ + "media/icons/plyny-eksploatacyjne-title@3x-a2dd9678.svg";